import { render } from "./ContactDetails.vue?vue&type=template&id=8b1387c0&scoped=true&ts=true"
import script from "./ContactDetails.vue?vue&type=script&lang=ts"
export * from "./ContactDetails.vue?vue&type=script&lang=ts"

import "./ContactDetails.vue?vue&type=style&index=0&id=8b1387c0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1387c0"]])

export default __exports__